var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    { ref: "validation", staticClass: "analise", attrs: { tag: "div" } },
    [
      _vm.processo && _vm.processo.id
        ? _c(
            "el-card",
            { staticClass: "card-collapse", attrs: { shadow: "hover" } },
            [
              _c(
                "el-col",
                { staticClass: "center", attrs: { span: 8 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Nome do Interessado:",
                      content: _vm.processo.nomeRazaoSocialInteressado
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Número do processo:",
                      content: _vm.processo.numeroProcesso
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "CPF do Interessado:",
                      content: _vm.processo.cpfCnpjInteressado
                    }
                  }),
                  _c("app-display", {
                    attrs: {
                      label: "Tipo de Processo:",
                      content: _vm.processo.tipo.nome
                    }
                  })
                ],
                1
              ),
              _c("app-opcoes-header-analise", {
                staticClass: "right",
                attrs: {
                  idProcesso: _vm.processo.id,
                  numeroProcesso: _vm.processo.numeroProcesso,
                  protocolo: _vm.processo.numeroProtocolo,
                  tipoProcesso: _vm.processo.tipo.codigo,
                  btnSolicitarInformacao: true,
                  btnRetificacao: false
                }
              })
            ],
            1
          )
        : _vm._e(),
      this.active === 0 &&
      _vm.processo &&
      _vm.processo.id &&
      (_vm.vtnExcedente ||
        _vm.processo.tipo.codigo === "ONEROSO" ||
        _vm.processo.tipo.codigo === "CERTIDAO_TITULO")
        ? _c(
            "el-card",
            { staticClass: "card-collapse", attrs: { shadow: "hover" } },
            [
              _c("app-radios-tramitacao", {
                attrs: {
                  radios: _vm.acaoParaEmissaoOuDespachoVtn,
                  isDecisao: true,
                  radioInicial: _vm.action
                },
                on: { changeRadio: _vm.changeRadioDespacho }
              })
            ],
            1
          )
        : _vm._e(),
      !_vm.isDespacho && _vm.processo && _vm.processo.id
        ? _c(
            "el-card",
            { staticClass: "card-container", attrs: { shadow: "hover" } },
            [
              _c(
                "div",
                [
                  _c(
                    "el-steps",
                    {
                      staticClass: "margin-top",
                      attrs: {
                        active: _vm.active,
                        "finish-status": "success",
                        simple: "simple"
                      }
                    },
                    [
                      _c("el-step", { attrs: { title: "Dados do VTN" } }),
                      _c("el-step", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.vtnExcedente,
                            expression: "!vtnExcedente"
                          }
                        ],
                        attrs: { title: "Dados da custas" }
                      }),
                      _c("el-step", { attrs: { title: "Confirmar dados" } })
                    ],
                    1
                  ),
                  _vm.active === 0
                    ? _c(
                        "validation-observer",
                        { ref: "validation", attrs: { tag: "div" } },
                        [
                          _c(
                            "el-row",
                            {
                              staticClass: "mb-20",
                              attrs: { type: "flex", gutter: 40 }
                            },
                            [
                              _c(
                                "el-col",
                                [
                                  _vm.processo.numeroProcesso
                                    ? _c("dados-vtn", {
                                        attrs: {
                                          numeroProcesso:
                                            _vm.processo.numeroProcesso,
                                          tipoProcesso: _vm.tipoProcesso,
                                          vtnExcedente: _vm.vtnExcedente
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.active === 1
                    ? _c("div", [_c("custas-vtn")], 1)
                    : _vm._e(),
                  _vm.active === 2
                    ? _c(
                        "div",
                        [
                          _c("app-dados-calculo-vtn", {
                            attrs: {
                              dadosVtn: _vm.dadosVtn,
                              tipoProcesso: _vm.tipoProcesso,
                              resumo: true,
                              calculoExcedente: _vm.vtnExcedente
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c("app-buttons-cadastro", {
                attrs: {
                  isUltimoPasso: _vm.active > 1,
                  isPrimeiroPasso: _vm.active === 0,
                  showButtonCancelar: _vm.active === 0,
                  showButtonProximo: _vm.active < 2
                },
                on: {
                  proximo: _vm.proximo,
                  voltar: _vm.voltar,
                  finalizar: _vm.finalizar,
                  cancelar: _vm.cancelar
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.processo && _vm.processo.id && _vm.isDespacho
        ? _c(
            "el-card",
            { staticClass: "card-container", attrs: { shadow: "hover" } },
            [
              _c(
                "validation-observer",
                {
                  ref: "validation",
                  staticClass: "analise",
                  attrs: { tag: "div" }
                },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(ref) {
                            var errors = ref.errors
                            return [
                              _vm.vtnExcedente
                                ? _c("el-alert", {
                                    staticClass: "alert",
                                    attrs: {
                                      title:
                                        "Ao encaminhar para o próximo setor, não haverá alteração no VTN já existente.",
                                      type: "warning",
                                      "show-icon": "show-icon",
                                      closable: false
                                    }
                                  })
                                : _vm._e(),
                              _c("app-label", {
                                staticClass: "input-text-editor",
                                attrs: { label: "Despacho" }
                              }),
                              _c("app-editor-texto", {
                                ref: "editorTexto",
                                staticClass: "input",
                                class: { erro: errors.length },
                                on: { onTextChange: _vm.onTextChange },
                                model: {
                                  value: _vm.despacho.textoDespacho,
                                  callback: function($$v) {
                                    _vm.$set(_vm.despacho, "textoDespacho", $$v)
                                  },
                                  expression: "despacho.textoDespacho"
                                }
                              }),
                              _c("span", { staticClass: "help erro" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3743608425
                    )
                  }),
                  _c("app-anexo", {
                    attrs: {
                      id: "upload-anexo-despacho",
                      files: _vm.despacho.documentos,
                      tipoExibir: "ANEXO_ANALISE"
                    },
                    on: {
                      uploadFile: _vm.uploadFile,
                      removeFile: _vm.removeFile,
                      downloadDocumentoCadastro: _vm.downloadDocumentoCadastro
                    }
                  }),
                  _c("app-radios-tramitacao", {
                    attrs: {
                      radios: _vm.acoesRadioDespacho,
                      isDecisao: false,
                      radioInicial: _vm.despacho.acao
                    },
                    on: { changeRadio: _vm.changeRadio }
                  }),
                  _c("app-buttons-cadastro", {
                    attrs: {
                      isUltimoPasso: false,
                      isPrimeiroPasso: true,
                      showButtonCancelar: _vm.active === 0,
                      showButtonProximo: false,
                      isDespacho: _vm.despacho.acao != null
                    },
                    on: {
                      proximo: _vm.proximo,
                      voltar: _vm.voltar,
                      finalizar: _vm.finalizarDespacho,
                      cancelar: _vm.cancelar
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4cc7ba36", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cc7ba36","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/CalcularVtn.vue
// module id = null
// module chunks = 